var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data
    ? _c(
        "div",
        [
          _c("Top"),
          _vm._v(" "),
          _c("div", { staticClass: "container" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _vm.type === "parents"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.parentsHeader
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.buildParentsText
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "h5",
                          { staticClass: "card-title text-primary-fh" },
                          [_vm._v("Mamma")]
                        ),
                        _vm._v(" "),
                        _c("label", [_vm._v("Förnamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.parents.mother.firstName,
                              expression: "parents.mother.firstName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Förnamn" },
                          domProps: { value: _vm.parents.mother.firstName },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.parents.mother,
                                  "firstName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Efternamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.parents.mother.lastName,
                              expression: "parents.mother.lastName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Efternamn" },
                          domProps: { value: _vm.parents.mother.lastName },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.parents.mother,
                                  "lastName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "btn-group" } }, [
                          _vm._v("Är hon i livet?")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group btn-group-toggle" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.parents.mother.alive === true
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.parents.mother.alive,
                                      expression: "parents.mother.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.parents.mother.alive,
                                      true
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.parents.mother,
                                        "alive",
                                        true
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Ja\n              ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.parents.mother.alive === false
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.parents.mother.alive,
                                      expression: "parents.mother.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.parents.mother.alive,
                                      false
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.parents.mother,
                                        "alive",
                                        false
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Nej\n              ")
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "h5",
                          { staticClass: "card-title text-primary-fh" },
                          [_vm._v("Mormor")]
                        ),
                        _vm._v(" "),
                        _c("label", [_vm._v("Förnamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandmother.firstName,
                              expression: "grandParents.grandmother.firstName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Förnamn" },
                          domProps: {
                            value: _vm.grandParents.grandmother.firstName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandmother,
                                  "firstName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Efternamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandmother.lastName,
                              expression: "grandParents.grandmother.lastName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Efternamn" },
                          domProps: {
                            value: _vm.grandParents.grandmother.lastName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandmother,
                                  "lastName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "btn-group" } }, [
                          _vm._v("Är hon i livet?")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group btn-group-toggle" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandmother.alive === true
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandmother.alive,
                                      expression:
                                        "grandParents.grandmother.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.grandParents.grandmother.alive,
                                      true
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandmother,
                                        "alive",
                                        true
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Ja\n              ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandmother.alive === false
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandmother.alive,
                                      expression:
                                        "grandParents.grandmother.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.grandParents.grandmother.alive,
                                      false
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandmother,
                                        "alive",
                                        false
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Nej\n              ")
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "h5",
                          { staticClass: "card-title text-primary-fh" },
                          [_vm._v("Morfar")]
                        ),
                        _vm._v(" "),
                        _c("label", [_vm._v("Förnamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandfather.firstName,
                              expression: "grandParents.grandfather.firstName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Förnamn" },
                          domProps: {
                            value: _vm.grandParents.grandfather.firstName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandfather,
                                  "firstName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Efternamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandfather.lastName,
                              expression: "grandParents.grandfather.lastName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Efternamn" },
                          domProps: {
                            value: _vm.grandParents.grandfather.lastName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandfather,
                                  "lastName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "btn-group" } }, [
                          _vm._v("Är han i livet?")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group btn-group-toggle" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandfather.alive === true
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandfather.alive,
                                      expression:
                                        "grandParents.grandfather.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.grandParents.grandfather.alive,
                                      true
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandfather,
                                        "alive",
                                        true
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Ja\n              ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandfather.alive === false
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandfather.alive,
                                      expression:
                                        "grandParents.grandfather.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.grandParents.grandfather.alive,
                                      false
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandfather,
                                        "alive",
                                        false
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Nej\n              ")
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "h5",
                          { staticClass: "card-title text-primary-fh" },
                          [_vm._v("Pappa")]
                        ),
                        _vm._v(" "),
                        _c("label", [_vm._v("Förnamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.parents.father.firstName,
                              expression: "parents.father.firstName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Förnamn" },
                          domProps: { value: _vm.parents.father.firstName },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.parents.father,
                                  "firstName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Efternamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.parents.father.lastName,
                              expression: "parents.father.lastName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Efternamn" },
                          domProps: { value: _vm.parents.father.lastName },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.parents.father,
                                  "lastName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "btn-group" } }, [
                          _vm._v("Är han i livet?")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group btn-group-toggle" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.parents.father.alive === true
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.parents.father.alive,
                                      expression: "parents.father.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.parents.father.alive,
                                      true
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.parents.father,
                                        "alive",
                                        true
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Ja\n              ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.parents.father.alive === false
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.parents.father.alive,
                                      expression: "parents.father.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.parents.father.alive,
                                      false
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.parents.father,
                                        "alive",
                                        false
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Nej\n              ")
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "h5",
                          { staticClass: "card-title text-primary-fh" },
                          [_vm._v("Farmor")]
                        ),
                        _vm._v(" "),
                        _c("label", [_vm._v("Förnamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandma.firstName,
                              expression: "grandParents.grandma.firstName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Förnamn" },
                          domProps: {
                            value: _vm.grandParents.grandma.firstName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandma,
                                  "firstName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Efternamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandma.lastName,
                              expression: "grandParents.grandma.lastName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Efternamn" },
                          domProps: {
                            value: _vm.grandParents.grandma.lastName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandma,
                                  "lastName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "btn-group" } }, [
                          _vm._v("Är hon i livet?")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group btn-group-toggle" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandma.alive === true
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandma.alive,
                                      expression: "grandParents.grandma.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.grandParents.grandma.alive,
                                      true
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandma,
                                        "alive",
                                        true
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Ja\n              ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandma.alive === false
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandma.alive,
                                      expression: "grandParents.grandma.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.grandParents.grandma.alive,
                                      false
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandma,
                                        "alive",
                                        false
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Nej\n              ")
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "card" }, [
                      _c("div", { staticClass: "card-body" }, [
                        _c(
                          "h5",
                          { staticClass: "card-title text-primary-fh" },
                          [_vm._v("Farfar")]
                        ),
                        _vm._v(" "),
                        _c("label", [_vm._v("Förnamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandpa.firstName,
                              expression: "grandParents.grandpa.firstName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Förnamn" },
                          domProps: {
                            value: _vm.grandParents.grandpa.firstName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandpa,
                                  "firstName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", [_vm._v("Efternamn")]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.grandParents.grandpa.lastName,
                              expression: "grandParents.grandpa.lastName"
                            }
                          ],
                          staticClass:
                            "form-control form-control-lg name-input",
                          attrs: { type: "text", placeholder: "Efternamn" },
                          domProps: {
                            value: _vm.grandParents.grandpa.lastName
                          },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.grandParents.grandpa,
                                  "lastName",
                                  $event.target.value
                                )
                              },
                              function($event) {
                                return _vm.checkInputs()
                              }
                            ],
                            keypress: function($event) {
                              return _vm.isLetterOrHyphen($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        _c("label", { attrs: { for: "btn-group" } }, [
                          _vm._v("Är han i livet?")
                        ]),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group btn-group-toggle" },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandpa.alive === true
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandpa.alive,
                                      expression: "grandParents.grandpa.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: true,
                                    checked: _vm._q(
                                      _vm.grandParents.grandpa.alive,
                                      true
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandpa,
                                        "alive",
                                        true
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Ja\n              ")
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                class:
                                  _vm.grandParents.grandpa.alive === false
                                    ? "active"
                                    : ""
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.grandParents.grandpa.alive,
                                      expression: "grandParents.grandpa.alive"
                                    }
                                  ],
                                  attrs: { type: "radio", autocomplete: "off" },
                                  domProps: {
                                    value: false,
                                    checked: _vm._q(
                                      _vm.grandParents.grandpa.alive,
                                      false
                                    )
                                  },
                                  on: {
                                    change: function($event) {
                                      return _vm.$set(
                                        _vm.grandParents.grandpa,
                                        "alive",
                                        false
                                      )
                                    }
                                  }
                                }),
                                _vm._v("Nej\n              ")
                              ]
                            )
                          ]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-lg btn-block btn-finish-relation",
                        attrs: { disabled: _vm.dirty },
                        on: {
                          click: function($event) {
                            return _vm.finishedRelation("parents")
                          }
                        }
                      },
                      [_vm._v("Klar")]
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "children"
                ? _c(
                    "div",
                    { staticClass: "col-md-6" },
                    [
                      _c("h2", {
                        staticClass: "text-primary-fh left-header",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.familytreedashboard.buildchildrenheader
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.data.familytreedashboard.buildChildrenText
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "card-preview minor-age-card" },
                        [
                          _c("p", [
                            _vm._v(
                              "Jag har barn under 13 år\n                   \n            "
                            ),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.minorAge,
                                  expression: "minorAge"
                                }
                              ],
                              staticClass:
                                "form-check-input minor-age-checkbox",
                              attrs: { type: "checkbox" },
                              domProps: {
                                checked: Array.isArray(_vm.minorAge)
                                  ? _vm._i(_vm.minorAge, null) > -1
                                  : _vm.minorAge
                              },
                              on: {
                                change: [
                                  function($event) {
                                    var $$a = _vm.minorAge,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          (_vm.minorAge = $$a.concat([$$v]))
                                      } else {
                                        $$i > -1 &&
                                          (_vm.minorAge = $$a
                                            .slice(0, $$i)
                                            .concat($$a.slice($$i + 1)))
                                      }
                                    } else {
                                      _vm.minorAge = $$c
                                    }
                                  },
                                  function($event) {
                                    return _vm.minorAgedChildren()
                                  }
                                ]
                              }
                            })
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm.children.length < 1
                        ? _c("div", { staticClass: "card-preview" }, [
                            _c(
                              "h5",
                              {
                                staticClass: "text-center card-preview-header"
                              },
                              [_vm._v("Inga barn tillagda")]
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm._l(_vm.children, function(c, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c("div", { staticClass: "card child-card" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "close",
                                  on: {
                                    click: function($event) {
                                      return _vm.removeRelative(_vm.children, i)
                                    }
                                  }
                                },
                                [_vm._v("×")]
                              ),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "text-primary-fh pull-right" },
                                [_vm._v("Barn")]
                              ),
                              _vm._v(" "),
                              _c("label", [_vm._v("Förnamn")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: c.firstName,
                                    expression: "c.firstName"
                                  }
                                ],
                                staticClass:
                                  "form-control form-control-lg name-input",
                                attrs: { type: "text", placeholder: "Förnamn" },
                                domProps: { value: c.firstName },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        c,
                                        "firstName",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      return _vm.checkInputs()
                                    }
                                  ],
                                  keypress: function($event) {
                                    return _vm.isLetterOrHyphen($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c("label", [_vm._v("Efternamn")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: c.lastName,
                                    expression: "c.lastName"
                                  }
                                ],
                                staticClass:
                                  "form-control form-control-lg name-input",
                                attrs: {
                                  type: "text",
                                  placeholder: "Efternamn"
                                },
                                domProps: { value: c.lastName },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        c,
                                        "lastName",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      return _vm.checkInputs()
                                    }
                                  ],
                                  keypress: function($event) {
                                    return _vm.isLetterOrHyphen($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "btn-group" } }, [
                                _vm._v("Är barnet i livet?")
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn-group btn-group-toggle",
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                      class: c.alive === true ? "active" : "",
                                      staticStyle: { background: "#fff" }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: c.alive,
                                            expression: "c.alive"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          autocomplete: "off"
                                        },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(c.alive, true)
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.$set(c, "alive", true)
                                          }
                                        }
                                      }),
                                      _vm._v("Ja\n                ")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                      class: c.alive === false ? "active" : "",
                                      staticStyle: { background: "#fff" }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: c.alive,
                                            expression: "c.alive"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          autocomplete: "off"
                                        },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(c.alive, false)
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.$set(c, "alive", false)
                                          }
                                        }
                                      }),
                                      _vm._v("Nej\n                ")
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary btn-lg btn-block add-grandchild-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.addGrandChild(i)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                Lägg till barnbarn\n              "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.grandChildren, function(gc, i) {
                        return _c(
                          "div",
                          { key: "gc-" + i, staticClass: "parent" },
                          [
                            _c("div", { staticClass: "card override-card" }, [
                              _c(
                                "div",
                                { staticClass: "card-body override-card-body" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "close",
                                      on: {
                                        click: function($event) {
                                          return _vm.removeRelative(
                                            _vm.grandChildren,
                                            i
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("×")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "small",
                                    {
                                      staticClass: "text-primary-fh pull-right"
                                    },
                                    [
                                      _vm._v("Barnbarn | Tillhör: "),
                                      _c("strong", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getNameByNode(
                                              gc.familyTreeParentNode
                                            )
                                          )
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Förnamn")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: gc.firstName,
                                        expression: "gc.firstName"
                                      }
                                    ],
                                    staticClass:
                                      "form-control form-control-lg name-input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Förnamn"
                                    },
                                    domProps: { value: gc.firstName },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            gc,
                                            "firstName",
                                            $event.target.value
                                          )
                                        },
                                        function($event) {
                                          return _vm.checkInputs()
                                        }
                                      ],
                                      keypress: function($event) {
                                        return _vm.isLetterOrHyphen($event)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _c("label", [_vm._v("Efternamn")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: gc.lastName,
                                        expression: "gc.lastName"
                                      }
                                    ],
                                    staticClass:
                                      "form-control form-control-lg name-input",
                                    attrs: {
                                      type: "text",
                                      placeholder: "Efternamn"
                                    },
                                    domProps: { value: gc.lastName },
                                    on: {
                                      input: [
                                        function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            gc,
                                            "lastName",
                                            $event.target.value
                                          )
                                        },
                                        function($event) {
                                          return _vm.checkInputs()
                                        }
                                      ],
                                      keypress: function($event) {
                                        return _vm.isLetterOrHyphen($event)
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" }),
                                  _vm._v(" "),
                                  _c("label", { attrs: { for: "btn-group" } }, [
                                    _vm._v("Är barnbarnet i livet?")
                                  ]),
                                  _c("br"),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "btn-group btn-group-toggle",
                                      staticStyle: { display: "flex" }
                                    },
                                    [
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                          class:
                                            gc.alive === true ? "active" : "",
                                          staticStyle: { background: "#fff" }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: gc.alive,
                                                expression: "gc.alive"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              autocomplete: "off"
                                            },
                                            domProps: {
                                              value: true,
                                              checked: _vm._q(gc.alive, true)
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.$set(
                                                  gc,
                                                  "alive",
                                                  true
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v("Ja\n                ")
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "label",
                                        {
                                          staticClass:
                                            "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                          class:
                                            gc.alive === false ? "active" : "",
                                          staticStyle: { background: "#fff" }
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: gc.alive,
                                                expression: "gc.alive"
                                              }
                                            ],
                                            attrs: {
                                              type: "radio",
                                              autocomplete: "off"
                                            },
                                            domProps: {
                                              value: false,
                                              checked: _vm._q(gc.alive, false)
                                            },
                                            on: {
                                              change: function($event) {
                                                return _vm.$set(
                                                  gc,
                                                  "alive",
                                                  false
                                                )
                                              }
                                            }
                                          }),
                                          _vm._v("Nej\n                ")
                                        ]
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "clearfix" })
                                ]
                              )
                            ])
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-primary btn-lg btn-block add-child-btn",
                          on: {
                            click: function($event) {
                              return _vm.addChild()
                            }
                          }
                        },
                        [_vm._v("\n          Lägg till barn\n        ")]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _vm.children.length >= 1
                        ? _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-primary btn-lg btn-block btn-finish-relation",
                              attrs: { disabled: _vm.dirty },
                              on: {
                                click: function($event) {
                                  return _vm.finishedRelation("children")
                                }
                              }
                            },
                            [_vm._v("Klar")]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _vm.children.length < 1
                        ? _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-lg btn-block",
                              on: {
                                click: function($event) {
                                  return _vm.noRelatives("children")
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          Jag har inga biologiska barn\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "modal fade",
                  attrs: {
                    id: "consentMinorModal",
                    role: "dialog",
                    "aria-labelledby": "consentMinorModalLabel",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog",
                      attrs: { role: "document" }
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c("h5", {
                            staticClass: "modal-title",
                            attrs: { id: "consentMinorModalLabel" },
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.data.familytree.consentMinorHeader
                              )
                            }
                          }),
                          _vm._v(" "),
                          _vm._m(1)
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "modal-body",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.data.familytree.consentMinorText
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              attrs: { type: "button", "data-dismiss": "modal" }
                            },
                            [_vm._v("Avbryt")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.giveConsentFinishRelation(true)
                                }
                              }
                            },
                            [_vm._v("Godkänn")]
                          )
                        ])
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _vm.type === "siblings"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.buildsiblingsheader
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.buildSiblingsText
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.siblings.length < 1
                      ? _c("div", { staticClass: "card-preview" }, [
                          _c(
                            "h5",
                            { staticClass: "text-center card-preview-header" },
                            [_vm._v("Inga helsyskon tillagda")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.siblings, function(s, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c("div", { staticClass: "card siblings-card" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "close",
                                  on: {
                                    click: function($event) {
                                      return _vm.removeRelative(_vm.siblings, i)
                                    }
                                  }
                                },
                                [_vm._v("×")]
                              ),
                              _vm._v(" "),
                              _c(
                                "small",
                                { staticClass: "text-primary-fh pull-right" },
                                [_vm._v("Syskon")]
                              ),
                              _vm._v(" "),
                              _c("label", [_vm._v("Förnamn")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: s.firstName,
                                    expression: "s.firstName"
                                  }
                                ],
                                staticClass:
                                  "form-control form-control-lg name-input",
                                attrs: { type: "text", placeholder: "Förnamn" },
                                domProps: { value: s.firstName },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        s,
                                        "firstName",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      return _vm.checkInputs()
                                    }
                                  ],
                                  keypress: function($event) {
                                    return _vm.isLetterOrHyphen($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c("label", [_vm._v("Efternamn")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: s.lastName,
                                    expression: "s.lastName"
                                  }
                                ],
                                staticClass:
                                  "form-control form-control-lg name-input",
                                attrs: {
                                  type: "text",
                                  placeholder: "Efternamn"
                                },
                                domProps: { value: s.lastName },
                                on: {
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        s,
                                        "lastName",
                                        $event.target.value
                                      )
                                    },
                                    function($event) {
                                      return _vm.checkInputs()
                                    }
                                  ],
                                  keypress: function($event) {
                                    return _vm.isLetterOrHyphen($event)
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c("label", { attrs: { for: "btn-group" } }, [
                                _vm._v("Är ditt helsyskon i livet?")
                              ]),
                              _c("br"),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "btn-group btn-group-toggle",
                                  staticStyle: { display: "flex" }
                                },
                                [
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                      class: s.alive === true ? "active" : "",
                                      staticStyle: { background: "#fff" }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: s.alive,
                                            expression: "s.alive"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          autocomplete: "off"
                                        },
                                        domProps: {
                                          value: true,
                                          checked: _vm._q(s.alive, true)
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.$set(s, "alive", true)
                                          }
                                        }
                                      }),
                                      _vm._v("Ja\n                  ")
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    {
                                      staticClass:
                                        "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                      class: s.alive === false ? "active" : "",
                                      staticStyle: { background: "#fff" }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: s.alive,
                                            expression: "s.alive"
                                          }
                                        ],
                                        attrs: {
                                          type: "radio",
                                          autocomplete: "off"
                                        },
                                        domProps: {
                                          value: false,
                                          checked: _vm._q(s.alive, false)
                                        },
                                        on: {
                                          change: function($event) {
                                            return _vm.$set(s, "alive", false)
                                          }
                                        }
                                      }),
                                      _vm._v("Nej\n                  ")
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary btn-lg btn-block add-siblingsChild-btn",
                                  on: {
                                    click: function($event) {
                                      return _vm.addSiblingsChild(i)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Lägg till syskonbarn\n                "
                                  )
                                ]
                              )
                            ])
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.siblingsChildren, function(n, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c("div", { staticClass: "card override-card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body override-card-body" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.siblingsChildren,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [
                                    _vm._v("Syskonbarn | Tillhör: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getNameByNode(
                                            n.familyTreeParentNode
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: n.firstName,
                                      expression: "n.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: n.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          n,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: n.lastName,
                                      expression: "n.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: n.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          n,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är ditt syskonbarn i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class: n.alive === true ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: n.alive,
                                              expression: "n.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(n.alive, true)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(n, "alive", true)
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          n.alive === false ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: n.alive,
                                              expression: "n.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(n.alive, false)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(n, "alive", false)
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-lg btn-block add-siblings-btn",
                        on: {
                          click: function($event) {
                            return _vm.addSibling()
                          }
                        }
                      },
                      [_vm._v("\n          Lägg till helsyskon\n        ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.siblings.length >= 1
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btn-block btn-finish-relation",
                            attrs: { disabled: _vm.dirty },
                            on: {
                              click: function($event) {
                                return _vm.finishedRelation("siblings")
                              }
                            }
                          },
                          [_vm._v("\n          Klar\n          ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.siblings.length < 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            on: {
                              click: function($event) {
                                return _vm.noRelatives("siblings")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Jag har inga helsyskon\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "motherhalfsiblings"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard
                            .buildmotherhalfsiblingsheader
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard
                            .buildMotherhalfsiblingsText
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.motherHalfSiblings.length < 1
                      ? _c("div", { staticClass: "card-preview" }, [
                          _c(
                            "h5",
                            { staticClass: "text-center card-preview-header" },
                            [_vm._v("Inga halvsyskon på mammas sida tillagda")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.motherHalfSiblings, function(mhs, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c(
                            "div",
                            { staticClass: "card motherhalfsiblings-card" },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.motherHalfSiblings,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [_vm._v("Halvsyskon")]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: mhs.firstName,
                                      expression: "mhs.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: mhs.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          mhs,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: mhs.lastName,
                                      expression: "mhs.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: mhs.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          mhs,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är halvsyskonet i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          mhs.alive === true ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: mhs.alive,
                                              expression: "mhs.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(mhs.alive, true)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                mhs,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          mhs.alive === false ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: mhs.alive,
                                              expression: "mhs.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(mhs.alive, false)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                mhs,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-lg btn-block add-motherhalfcousins-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.addMotherHalfCousin(i)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Lägg till barn till halvsyskon\n                "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.motherHalfCousins, function(mhc, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c("div", { staticClass: "card override-card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body override-card-body" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.motherHalfCousins,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [
                                    _vm._v("Halvsyskonbarn | Tillhör: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getNameByNode(
                                            mhc.familyTreeParentNode
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: mhc.firstName,
                                      expression: "mhc.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: mhc.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          mhc,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: mhc.lastName,
                                      expression: "mhc.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: mhc.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          mhc,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är halvsyskonets barn i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          mhc.alive === true ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: mhc.alive,
                                              expression: "mhc.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(mhc.alive, true)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                mhc,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          mhc.alive === false ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: mhc.alive,
                                              expression: "mhc.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(mhc.alive, false)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                mhc,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-lg btn-block add-motherhalfsiblings-btn",
                        on: {
                          click: function($event) {
                            return _vm.addMotherHalfSibling()
                          }
                        }
                      },
                      [_vm._v("\n          Lägg till halvsyskon\n        ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.motherHalfSiblings.length >= 1
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btn-block btn-finish-relation",
                            attrs: { disabled: _vm.dirty },
                            on: {
                              click: function($event) {
                                return _vm.finishedRelation(
                                  "motherhalfsiblings"
                                )
                              }
                            }
                          },
                          [_vm._v("\n          Klar\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.motherHalfSiblings.length < 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            on: {
                              click: function($event) {
                                return _vm.noRelatives("motherhalfsiblings")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Inga halvsyskon på mammas sida\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "fatherhalfsiblings"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard
                            .buildfatherhalfsiblingsheader
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard
                            .buildFatherhalfsiblingsText
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.fatherHalfSiblings.length < 1
                      ? _c("div", { staticClass: "card-preview" }, [
                          _c(
                            "h5",
                            { staticClass: "text-center card-preview-header" },
                            [_vm._v("Inga halvsyskon på pappas sida tillagda")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.fatherHalfSiblings, function(fhs, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c(
                            "div",
                            { staticClass: "card fatherhalfsiblings-card" },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.fatherHalfSiblings,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [_vm._v("Halvsyskon")]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: fhs.firstName,
                                      expression: "fhs.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: fhs.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          fhs,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: fhs.lastName,
                                      expression: "fhs.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: fhs.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          fhs,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är halvsyskonet i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          fhs.alive === true ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: fhs.alive,
                                              expression: "fhs.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(fhs.alive, true)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                fhs,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          fhs.alive === false ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: fhs.alive,
                                              expression: "fhs.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(fhs.alive, false)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                fhs,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-lg btn-block add-fatherhalfcousins-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.addFatherHalfCousin(i)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Lägg till barn till halvsyskon\n                "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.fatherHalfCousins, function(fhc, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c("div", { staticClass: "card override-card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body override-card-body" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.fatherHalfCousins,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [
                                    _vm._v("Halvsyskonbarn | Tillhör: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getNameByNode(
                                            fhc.familyTreeParentNode
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: fhc.firstName,
                                      expression: "fhc.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: fhc.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          fhc,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: fhc.lastName,
                                      expression: "fhc.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: fhc.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          fhc,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är halvsyskonets barn i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          fhc.alive === true ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: fhc.alive,
                                              expression: "fhc.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(fhc.alive, true)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                fhc,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          fhc.alive === false ? "active" : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: fhc.alive,
                                              expression: "fhc.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(fhc.alive, false)
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                fhc,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-lg btn-block add-fatherhalfsiblings-btn",
                        on: {
                          click: function($event) {
                            return _vm.addFatherHalfSibling()
                          }
                        }
                      },
                      [_vm._v("\n          Lägg till halvsyskon\n        ")]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.fatherHalfSiblings.length >= 1
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btn-block btn-finish-relation",
                            attrs: { disabled: _vm.dirty },
                            on: {
                              click: function($event) {
                                return _vm.finishedRelation(
                                  "fatherhalfsiblings"
                                )
                              }
                            }
                          },
                          [_vm._v("\n          Klar\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.fatherHalfSiblings.length < 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            on: {
                              click: function($event) {
                                return _vm.noRelatives("fatherhalfsiblings")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Inga halvsyskon på pappas sida\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "mothercousins"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.buildmothercousinsheader
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.buildMothercousinsText
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.motherSiblings.length < 1
                      ? _c("div", { staticClass: "card-preview" }, [
                          _c(
                            "h5",
                            { staticClass: "text-center card-preview-header" },
                            [_vm._v("Inga syskon på mammas sida tillagda")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.motherSiblings, function(momSibling, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c(
                            "div",
                            { staticClass: "card mothersiblings-card" },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.motherSiblings,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [_vm._v("Syskon till mamma")]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: momSibling.firstName,
                                      expression: "momSibling.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: momSibling.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          momSibling,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: momSibling.lastName,
                                      expression: "momSibling.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: momSibling.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          momSibling,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är syskonet till mamma i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          momSibling.alive === true
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: momSibling.alive,
                                              expression: "momSibling.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              momSibling.alive,
                                              true
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                momSibling,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          momSibling.alive === false
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: momSibling.alive,
                                              expression: "momSibling.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              momSibling.alive,
                                              false
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                momSibling,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-lg btn-block add-mothercousin-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.addMotherCousin(i)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Lägg till kusin\n                "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.motherCousins, function(momCousin, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c("div", { staticClass: "card override-card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body override-card-body" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.motherCousins,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [
                                    _vm._v("Kusin | Tillhör: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getNameByNode(
                                            momCousin.familyTreeParentNode
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: momCousin.firstName,
                                      expression: "momCousin.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: momCousin.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          momCousin,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: momCousin.lastName,
                                      expression: "momCousin.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: momCousin.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          momCousin,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är kusinen i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          momCousin.alive === true
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: momCousin.alive,
                                              expression: "momCousin.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              momCousin.alive,
                                              true
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                momCousin,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          momCousin.alive === false
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: momCousin.alive,
                                              expression: "momCousin.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              momCousin.alive,
                                              false
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                momCousin,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-lg btn-block add-mothersibling-btn",
                        on: {
                          click: function($event) {
                            return _vm.addMotherSibling()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          Lägg till syskon på mammas sida\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.motherSiblings.length >= 1
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btn-block btn-finish-relation",
                            attrs: { disabled: _vm.dirty },
                            on: {
                              click: function($event) {
                                return _vm.finishedRelation("mothercousins")
                              }
                            }
                          },
                          [_vm._v("\n          Klar\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.motherSiblings.length < 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            on: {
                              click: function($event) {
                                return _vm.noRelatives("mothercousins")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n        Inga syskon på mammas sida\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.type === "fathercousins"
                ? _c("div", { staticClass: "col-md-6" }, [
                    _c("h2", {
                      staticClass: "text-primary-fh left-header",
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.buildfathercousinsheader
                        )
                      }
                    }),
                    _vm._v(" "),
                    _c("p", {
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.data.familytreedashboard.buildFathercousinsText
                        )
                      }
                    }),
                    _vm._v(" "),
                    _vm.fatherSiblings.length < 1
                      ? _c("div", { staticClass: "card-preview" }, [
                          _c(
                            "h5",
                            { staticClass: "text-center card-preview-header" },
                            [_vm._v("Inga syskon på pappas sida tillagda")]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.fatherSiblings, function(dadSibling, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c(
                            "div",
                            { staticClass: "card fathersiblings-card" },
                            [
                              _c("div", { staticClass: "card-body" }, [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.fatherSiblings,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [_vm._v("Syskon till pappa")]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: dadSibling.firstName,
                                      expression: "dadSibling.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: dadSibling.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          dadSibling,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: dadSibling.lastName,
                                      expression: "dadSibling.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: dadSibling.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          dadSibling,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är syskonet till pappa i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          dadSibling.alive === true
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: dadSibling.alive,
                                              expression: "dadSibling.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              dadSibling.alive,
                                              true
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                dadSibling,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          dadSibling.alive === false
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: dadSibling.alive,
                                              expression: "dadSibling.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              dadSibling.alive,
                                              false
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                dadSibling,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-lg btn-block add-fathercousin-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.addFatherCousin(i)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                  Lägg till kusin\n                "
                                    )
                                  ]
                                )
                              ])
                            ]
                          )
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      _vm._l(_vm.fatherCousins, function(dadCousin, i) {
                        return _c("div", { key: i, staticClass: "parent" }, [
                          _c("div", { staticClass: "card override-card" }, [
                            _c(
                              "div",
                              { staticClass: "card-body override-card-body" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "close",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeRelative(
                                          _vm.fatherCousins,
                                          i
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("×")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "small",
                                  { staticClass: "text-primary-fh pull-right" },
                                  [
                                    _vm._v("Kusin | Tillhör: "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.getNameByNode(
                                            dadCousin.familyTreeParentNode
                                          )
                                        )
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("label", [_vm._v("Förnamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: dadCousin.firstName,
                                      expression: "dadCousin.firstName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Förnamn"
                                  },
                                  domProps: { value: dadCousin.firstName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          dadCousin,
                                          "firstName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", [_vm._v("Efternamn")]),
                                _vm._v(" "),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: dadCousin.lastName,
                                      expression: "dadCousin.lastName"
                                    }
                                  ],
                                  staticClass:
                                    "form-control form-control-lg name-input",
                                  attrs: {
                                    type: "text",
                                    placeholder: "Efternamn"
                                  },
                                  domProps: { value: dadCousin.lastName },
                                  on: {
                                    input: [
                                      function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          dadCousin,
                                          "lastName",
                                          $event.target.value
                                        )
                                      },
                                      function($event) {
                                        return _vm.checkInputs()
                                      }
                                    ],
                                    keypress: function($event) {
                                      return _vm.isLetterOrHyphen($event)
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("label", { attrs: { for: "btn-group" } }, [
                                  _vm._v("Är kusinen i livet?")
                                ]),
                                _c("br"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "btn-group btn-group-toggle",
                                    staticStyle: { display: "flex" }
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          dadCousin.alive === true
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: dadCousin.alive,
                                              expression: "dadCousin.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: true,
                                            checked: _vm._q(
                                              dadCousin.alive,
                                              true
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                dadCousin,
                                                "alive",
                                                true
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Ja\n                  ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg btn-override btn-alive",
                                        class:
                                          dadCousin.alive === false
                                            ? "active"
                                            : "",
                                        staticStyle: { background: "#fff" }
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: dadCousin.alive,
                                              expression: "dadCousin.alive"
                                            }
                                          ],
                                          attrs: {
                                            type: "radio",
                                            autocomplete: "off"
                                          },
                                          domProps: {
                                            value: false,
                                            checked: _vm._q(
                                              dadCousin.alive,
                                              false
                                            )
                                          },
                                          on: {
                                            change: function($event) {
                                              return _vm.$set(
                                                dadCousin,
                                                "alive",
                                                false
                                              )
                                            }
                                          }
                                        }),
                                        _vm._v("Nej\n                  ")
                                      ]
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" })
                              ]
                            )
                          ])
                        ])
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-primary btn-lg btn-block add-fathersibling-btn",
                        on: {
                          click: function($event) {
                            return _vm.addFatherSibling()
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n          Lägg till syskon på pappas sida\n        "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.fatherSiblings.length >= 1
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-primary btn-lg btn-block btn-finish-relation",
                            attrs: { disabled: _vm.dirty },
                            on: {
                              click: function($event) {
                                return _vm.finishedRelation("fathercousins")
                              }
                            }
                          },
                          [_vm._v("\n          Klar\n        ")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _vm.fatherSiblings.length < 1
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-lg btn-block",
                            on: {
                              click: function($event) {
                                return _vm.noRelatives("fathercousins")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n          Inga syskon på pappas sida\n        "
                            )
                          ]
                        )
                      : _vm._e()
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-sm" }),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-6" }, [
                _c("div", { staticClass: "clearfix" }),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary btn-lg btn-block",
                    on: {
                      click: function($event) {
                        return _vm.$router.go(-1)
                      }
                    }
                  },
                  [_vm._v("\n          ← Tillbaka\n        ")]
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm" })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
          _vm._v(" "),
          _c("Bottom")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm" }),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" }, [
        _c("div", { staticClass: "clearfix" }),
        _vm._v(" "),
        _c("br")
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close",
        attrs: {
          type: "button",
          "data-dismiss": "modal",
          "aria-label": "Close"
        }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-429f0328", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-429f0328","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FamilyTreeBuild.vue
// module id = null
// module chunks = 